/*  ==============================================
//  Created by nguyendx                          ||
//  create at: 2017-10-05                        ||
//===============================================*/
import {Component, Injectable, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService} from 'primeng/primeng';
import {Location} from '@angular/common';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: "box_scan_default",
    templateUrl: './box_scan_default.component.html',
    styleUrls: ['./scan.css'],
    providers: [ConfirmationService]
})

@Injectable()
export class ScanDefaultComponent implements OnInit {

    constructor(private _location: Location,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private confirmationService: ConfirmationService,
                private _fb: FormBuilder) {
        let body = document.getElementsByTagName('body')[0];
        body.classList.add("animsition");   //add the class
        body.classList.add("layout-full");   //add the class
    }

    ngOnInit() {

    }

    backToComponent() {
        this._location.back();
    }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/scan/box_scan_default.component.ts